<template>
  <v-row justify="center">
    <v-card class="pa-5" style="margin-top: 30vh; width: 28%" color="#2e3c56">
      <template>
          <div style="min-height: 4px;">
            <v-progress-linear
                :active="loading"
                :indeterminate="loading"
            ></v-progress-linear>
          </div>
        </template>
      <v-img
          class="ma-5"
          :src="imageAsset"
      ></v-img>
      <v-text-field @keyup.enter="handleLogin" label="Email" type="text" v-model="login.email"
                    dark/>
      <v-text-field @keyup.enter="handleLogin" label="Password" type="password" v-model="login.password" dark/>

      <v-row justify="end">
        <v-btn @click="handleLogin" text dark>Login</v-btn>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

const imageAsset = require('../../assets/company-logo.svg')

export default {
  name: "Login",
  computed: {
    ...mapState('auth', ['login', 'loading'])
  },
  methods: {
    ...mapMutations('auth', ['setLoginParam']),
    ...mapActions('auth', ['handleLogin']),
  },
  data() {
    return {
      imageAsset
    }
  },
}
</script>

<style scoped>

</style>